import { render, staticRenderFns } from "./Lists.vue?vue&type=template&id=6c2b9c62&scoped=true&"
import script from "./Lists.vue?vue&type=script&lang=js&"
export * from "./Lists.vue?vue&type=script&lang=js&"
import style0 from "./Lists.vue?vue&type=style&index=0&id=6c2b9c62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2b9c62",
  null
  
)

export default component.exports